// extracted by mini-css-extract-plugin
export default {"validationMessage":"validationMessage---m1DZw"};